export const KURAL_CHART_COLOR_PALETTE = [
	"#76C2AC",
	"#4B83DC",
	"#9681E2",
	"#9939F3",
	"#EA39F3",
	"#2EB8BA",
	"#809C41",
	"#65D9FF",
	"#714EAD",
	"#65249C",
	"#862778",
	"#C089E7",
	"#1F7197",
	"#56B0DA",
] as const;
